import React from 'react';
import {Redirect} from 'react-router-dom';
import {
  DOCUMENTATION_LANDING_URL,
  ROUTE_ACCESS_RULES,
  ROUTE_ENV_RULES,
} from 'configs';
import Error from 'views/errors';
import verifyCertificates from './verify-certificates';
import services from './services';
import about from './about';
import accreditationBody from './accreditation-body';
import activate from './activate';
import certification from './certification';
import certificationBody from './certification-body';
import certifiedEntity from './certified-entity';
import lettersOfSupport from './letters-of-support';
// import certifiedMarketplace from './certified-marketplace';
import coming from './coming';
import companyProfile from './company-profile';
import consents from './consents';
import contact from './contact';
import dashboard from './dashboard';
import downloads from './downloads';
import elinks from './elinks';
import enquiries from './enquiries';
import forgot from './forgot';
import help from './help';
import landing from './landing';
import login from './login';
import logout from './logout';
import marks from './marks';
import policies from './policies';
import redirect from './redirect';
import register from './register';
import reset from './reset';
import search from './search';
import settings from './settings';
import setup from './setup';
import users from './users';
import watchList from './watch-list';
import searchHistory from './search-history';
import standards from './standards';
import publicEnquiry from './enquiry';
import promotions from './promotions';
import companyList from './company-list';

import importManagement from './import-management';
import importSettings from './import-settings';
import companySettings from './company-settings';
import membership from './membership';
import plans from './plans';

import {
  ENABLE_ACTIVATION,
  ENABLE_ANALYTICS,
  ENABLE_FREE_TRIAL,
  ENABLE_ISO_SURVEY,
} from 'configs/enable-features';
import certifications from './certifications';
import certificationsList from './certifications-list';
import ceProfile from './ce-profile';
import apiSettings from './api-settings';
import advancedSearch from './advanced-search';
import freeTrial from './free-trial';
import analytics from './analytics';
import {discountsValidate, discountsVerify} from './discounts';
import {DISCOUNT_CODE} from 'configs/subscription';

// import analytics from './analytics';

/*
Example:
{
env: ROUTE_ENV_RULES.development,
access: ROUTE_ACCESS_RULES.public,
...certification,
},
*/

export const Replace = ({to}) => {
  React.useEffect(() => {
    window.location.replace(to);
  }, []);
  return null;
};

const routes = [
  {
    access: ROUTE_ACCESS_RULES.public,
    ...about,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...accreditationBody,
  },
  ENABLE_ACTIVATION && {
    access: ROUTE_ACCESS_RULES.public,
    ...activate,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...certification,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...certificationBody,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...certifiedEntity,
  },
  /*{
    access: ROUTE_ACCESS_RULES.private,
    ...certifiedMarketplace,
  },*/
  {
    access: ROUTE_ACCESS_RULES.public,
    ...coming,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...companyProfile,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...companyList,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...consents,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...contact,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...dashboard,
  },
  ENABLE_ANALYTICS &&
    ENABLE_ISO_SURVEY && {
      access: ROUTE_ACCESS_RULES.private,
      suspendedAccessible: true,
      ...analytics,
    },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...downloads,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...elinks,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    // suspendedAccessible: true,
    ...enquiries,
  },
  {
    access: ROUTE_ACCESS_RULES.guest,
    ...forgot,
  },
  {
    env: ROUTE_ENV_RULES.development,
    access: ROUTE_ACCESS_RULES.public,
    ...help,
  },
  {
    access: ROUTE_ACCESS_RULES.guest,
    ...landing,
  },

  {
    access: ROUTE_ACCESS_RULES.public,
    ...login,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...logout,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...marks,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...policies,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...redirect,
  },
  {
    access: ROUTE_ACCESS_RULES.guest,
    ...register,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...reset,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...search,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...settings,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...setup,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...standards,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...advancedSearch,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...users,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...watchList,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...searchHistory,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...publicEnquiry,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...lettersOfSupport,
  },
  {
    access: ROUTE_ACCESS_RULES.guest,
    ...promotions,
  },
  !!DISCOUNT_CODE && {
    access: ROUTE_ACCESS_RULES.guest,
    ...discountsValidate,
  },
  !!DISCOUNT_CODE && {
    access: ROUTE_ACCESS_RULES.guest,
    ...discountsVerify,
  },
  {
    access: ROUTE_ACCESS_RULES.guest,
    ...verifyCertificates,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...importManagement,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...importSettings,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...companySettings,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...membership,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...plans,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...certificationsList,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...ceProfile,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    ...certifications,
  },
  {
    access: ROUTE_ACCESS_RULES.private,
    suspendedAccessible: true,
    ...apiSettings,
  },
  ENABLE_FREE_TRIAL && {
    access: ROUTE_ACCESS_RULES.guest,
    ...freeTrial,
  },
  {
    access: ROUTE_ACCESS_RULES.public,
    ...services,
  },
  {
    path: '/user-guide',
    component: () => <Replace to={DOCUMENTATION_LANDING_URL} />,
  },
  {
    exact: true,
    path: '/error/:code',
    component: Error,
  },
  {
    exact: true,
    path: '/not-found',
    component: Error,
  },
  {
    component: () => {
      return <Redirect to="/not-found" />;
    },
  },
].filter((v) => v);

export default routes;
